export const TabPanel = (props) => {
    const { children, value, index, inputWidth, ...rest } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
            style={{ width: inputWidth }}
            {...rest}>
            {value === index && children}
        </div>
    )
}
